module.exports = {
  messages: {
    DREAM_MACHINE_ABOUT_AVAILABLE_JOBS_DESCRIPTION:
      'Für Job-Vorschläge nutzen wir folgende Daten:\n* Deine Profilangaben\n* Deine Job-Wünsche\n* Deinen Suchverlauf\n* Deine kürzlich angesehenen Jobs',
    DREAM_MACHINE_ABOUT_AVAILABLE_JOBS_INTRO_IOS:
      'Für Job-Vorschläge nutzen wir folgende Daten:',
    DREAM_MACHINE_ABOUT_AVAILABLE_JOBS_ITEMS_IOS:
      'Deine Profilangaben|Deine Job-Wünsche|Deinen Suchverlauf|Deine kürzlich angesehenen Jobs',
    DREAM_MACHINE_ABOUT_AVAILABLE_JOBS_TITLE: 'Hinweis zu Job-Vorschlägen',
    DREAM_MACHINE_ABOUT_BUTTON_LABEL: 'Alles klar!',
    DREAM_MACHINE_ABOUT_OCCUPIED_JOBS_DESCRIPTION:
      'Wenn Du Profile entdeckst, wischst oder ein „Gefällt mir“ oder „Gefällt mir nicht mehr“ setzt, können andere Mitglieder sehen, dass Du ihr Profil oder Teile davon eingesehen hast. Mehr zum Thema „Klickpfad“ findest Du in der [Datenschutzerklärung](https://privacy.xing.com/de/datenschutzerklaerung/informationen-die-wir-auf-grund-ihrer-nutzung-von-xing-automatisch-erhalten/bereitstellung-unseres-dienstes/beispiele).',
    DREAM_MACHINE_ABOUT_OCCUPIED_JOBS_TITLE: 'Übrigens:',
    DREAM_MACHINE_ACTIVITY_BACK_BUTTON_A11Y: 'Zurück',
    DREAM_MACHINE_ACTIVITY_BANNER_REMINDER_DISABLED:
      'Bewerbungswecker deaktiviert. Du erhältst keine Erinnerungen mehr.',
    DREAM_MACHINE_ACTIVITY_BANNER_REMINDER_ENABLED:
      'Du erhältst Erinnerungen für diesen Job.',
    DREAM_MACHINE_ACTIVITY_LIKES_EMPTY_LABEL:
      'Du hast noch keinen Job gespeichert.',
    DREAM_MACHINE_ACTIVITY_LIKES_HEADER: 'Gefällt Dir',
    DREAM_MACHINE_ACTIVITY_MENU_VIEW_DELETE_JOB: 'Auftrag löschen',
    DREAM_MACHINE_ACTIVITY_MENU_VIEW_JOB_AVAILABLE: 'Job ansehen und bewerben',
    DREAM_MACHINE_ACTIVITY_MENU_VIEW_JOB_TAKEN:
      'Job ansehen und bewerben\n(Dieser Job ist aktuell vergeben)',
    DREAM_MACHINE_ACTIVITY_REMINDER_BUTTON_DISABLE: 'Erinnerung ausschalten',
    DREAM_MACHINE_ACTIVITY_REMINDER_BUTTON_ENABLE: 'Erinnerung setzen',
    DREAM_MACHINE_ACTIVITY_REMINDERS_EMPTY_LABEL:
      'Du hast noch keine Erinnerungen aktiviert.',
    DREAM_MACHINE_ACTIVITY_REMINDERS_HEADER: 'Bewerbungswecker',
    DREAM_MACHINE_ACTIVITY_TITLE: 'Diese Jobs interessieren Dich',
    DREAM_MACHINE_BOOKMARK_BUTTON_TAPPED_BANNER:
      'Du erhältst Erinnerungen für diesen Job.',
    DREAM_MACHINE_CARD_TILE_CLICK_LABEL_A11Y: 'Mehr Details',
    DREAM_MACHINE_EMPTY_STATE_DESCRIPTION:
      'Die Einrichtung & Optimierung kann einige Stunden dauern. Du könntest solange Dein Profil vervollständigen, damit wir Dir bessere Empfehlungen geben können.',
    DREAM_MACHINE_EMPTY_STATE_TITLE:
      'Wir richten gerade alle Funktionen für Dich ein',
    DREAM_MACHINE_END_GAME_BODY:
      'Schau die Jobs an, die Dir gefallen haben – vielleicht willst du dich ja direkt bewerben.',
    DREAM_MACHINE_END_GAME_CANCEL_BUTTON: 'Vielleicht später',
    DREAM_MACHINE_END_GAME_REVIEW_BUTTON: 'Gemerkte Jobs ansehen',
    DREAM_MACHINE_END_GAME_TITLE: 'Kurz mal innehalten?',
    DREAM_MACHINE_END_OF_GAME_BODY:
      'Schau die Jobs an, die Dir gefallen haben und auf die Du Dich direkt bewerben kannst.',
    DREAM_MACHINE_END_OF_GAME_CTA: 'Gemerkte Jobs ansehen',
    DREAM_MACHINE_END_OF_GAME_NEGATIVE_BUTTON: 'Vielleicht später',
    DREAM_MACHINE_END_OF_GAME_TITLE: 'Kurz mal innehalten',
    DREAM_MACHINE_ENTRY_POINT_BODY:
      'Swipe Dich durch Deine Möglichkeiten und lass Dich von anderen für Deinen nächsten Karriere-Schritt inspirieren.',
    DREAM_MACHINE_ENTRY_POINT_CARD_TITLE:
      'Die besten Jobs sind schon vergeben?',
    DREAM_MACHINE_ENTRY_POINT_CTA_BUTTON: 'Jetzt entdecken',
    DREAM_MACHINE_ENTRY_POINT_NEW_MARKER: 'Neu',
    DREAM_MACHINE_ENTRY_POINT_REMINDERS_BUTTON: 'Bewerbungswecker',
    DREAM_MACHINE_ENTRY_POINT_SUBTITLE:
      'Heute noch besetzt, demnächst vielleicht schon Deiner.',
    DREAM_MACHINE_ENTRY_POINT_TITLE: 'Entdecke Deine Job-Chancen von morgen',
    DREAM_MACHINE_ENTRY_POINT_TITLE_WEB:
      'Hier sind die besten Jobs für Dich. Sogar die aktuell besetzten.',
    DREAM_MACHINE_ERROR_DELETING_JOB:
      'Das könnte am Server oder an Deiner Internetverbindung liegen. Lade die Seite sonst einfach nochmal neu. ',
    DREAM_MACHINE_ERROR_FULL_VIEW_ACTION: 'Seite neu laden',
    DREAM_MACHINE_ERROR_FULL_VIEW_DESCRIPTION:
      'Das könnte am Server oder an Deiner Internetverbindung liegen. Lade die Seite sonst einfach nochmal neu.',
    DREAM_MACHINE_ERROR_FULL_VIEW_TITLE: 'Das hat nicht geklappt',
    DREAM_MACHINE_ERROR_GENERIC_STATUS_BANNER:
      'Das könnte am Server oder an Deiner Internetverbindung liegen. Lade die Seite sonst einfach nochmal neu. ',
    DREAM_MACHINE_ERROR_UPDATING_INTERACTION:
      'Das könnte am Server oder an Deiner Internetverbindung liegen. Lade die Seite sonst einfach nochmal neu. ',
    DREAM_MACHINE_FEEDBACK_BETA_SURVEY_BODY:
      'Dein Feedback hilft uns dabei, an den richtigen Stellschrauben zu drehen.',
    DREAM_MACHINE_FEEDBACK_BETA_SURVEY_CTA: 'Jetzt Feedback geben',
    DREAM_MACHINE_FEEDBACK_BETA_SURVEY_NEGATIVE_BUTTON:
      'Später. Zeigt mir lieber nochmal 40 Karten.',
    DREAM_MACHINE_FEEDBACK_BETA_SURVEY_THANK_YOU: 'Danke!',
    DREAM_MACHINE_FEEDBACK_BETA_SURVEY_TITLE: 'Sag uns, was Du denkst',
    DREAM_MACHINE_GAME_ACTIVITY_BUTTON_A11Y: 'Aktivität anzeigen',
    DREAM_MACHINE_GAME_BUTTON_BOOKMARK_CONTENT_DESCRIPTION_A11Y: 'Job merken',
    DREAM_MACHINE_GAME_BUTTON_DISLIKE_CONTENT_DESCRIPTION_A11Y:
      'Job mit "gefällt mir nicht" markieren',
    DREAM_MACHINE_GAME_BUTTON_LIKE_CONTENT_DESCRIPTION_A11Y:
      'Job mit "gefällt mir" markieren',
    DREAM_MACHINE_GAME_BUTTON_NOTIFY_CONTENT_DESCRIPTION_A11Y:
      'Benachrichtigt mich',
    DREAM_MACHINE_GAME_EXIT_BUTTON: 'Schließen',
    DREAM_MACHINE_GAME_TITLE: 'Your Dream Jobs',
    DREAM_MACHINE_GAME_TITLE_IOS: 'Alle Jobs. Wirklich alle Jobs!',
    DREAM_MACHINE_GAME_TUTORIAL_BUTTON_A11Y: 'Anweisungen',
    DREAM_MACHINE_GAME_TUTORIAL_NOTIFY_ME_DESC:
      'und lass Dich <b>benachrichtigen</b>, sobald eine Stelle verfügbar wird.',
    DREAM_MACHINE_GAME_TUTORIAL_NOTIFY_ME_DESC_IOS:
      'und lass Dich **benachrichtigen**, sobald eine Stelle verfügbar wird.',
    DREAM_MACHINE_GAME_TUTORIAL_NOTIFY_ME_TITLE: 'Aktivier die Glocke',
    DREAM_MACHINE_GAME_TUTORIAL_REVIEW_DESC:
      'falls Du Deine Meinung noch ändern möchtest.',
    DREAM_MACHINE_GAME_TUTORIAL_REVIEW_TITLE: 'Schau Dir Deine Jobs an',
    DREAM_MACHINE_GAME_TUTORIAL_SWIPE_LEFT_DESC:
      'oder <b>Daumen runter</b>, bei Jobs, die Dich nicht interessieren.',
    DREAM_MACHINE_GAME_TUTORIAL_SWIPE_LEFT_DESC_IOS:
      'oder **Daumen runter**, bei Jobs, die Dich nicht interessieren.',
    DREAM_MACHINE_GAME_TUTORIAL_SWIPE_LEFT_TITLE: 'Wisch nach links',
    DREAM_MACHINE_GAME_TUTORIAL_SWIPE_RIGHT_DESC:
      'oder <b>Daumen hoch</b>, um einen Job für später zu speichern.',
    DREAM_MACHINE_GAME_TUTORIAL_SWIPE_RIGHT_DESC_IOS:
      'oder **Daumen hoch**, um einen Job für später zu speichern.',
    DREAM_MACHINE_GAME_TUTORIAL_SWIPE_RIGHT_TITLE: 'Wisch nach rechts',
    DREAM_MACHINE_GAME_TUTORIAL_VOMP_NOTICE_DESC_IOS:
      'Wenn Du Profile entdeckst, wischst oder ein „Gefällt mir“ oder „Gefällt mir nicht mehr“ setzt, können andere Mitglieder sehen, dass Du ihr Profil oder Teile davon eingesehen hast. Mehr zum Thema „Klickpfad“ findest Du in der [Datenschutzerklärung](https://privacy.xing.com/de/datenschutzerklaerung/informationen-die-wir-auf-grund-ihrer-nutzung-von-xing-automatisch-erhalten/bereitstellung-unseres-dienstes/beispiele).',
    DREAM_MACHINE_GAME_TUTORIAL_VOMP_NOTICE_DESC_WEB:
      'Wenn Du Profile entdeckst, wischst oder ein „Gefällt mir“ oder „Gefällt mir nicht mehr“ setzt, können andere Mitglieder sehen, dass Du ihr Profil oder Teile davon eingesehen hast. Mehr zum Thema „Klickpfad“ findest Du in der <a>Datenschutzerklärung</a>.',
    DREAM_MACHINE_GAME_TUTORIAL_VOMP_NOTICE_TITLE: 'Übrigens:',
    DREAM_MACHINE_GAME_TUTORIAL_VOMP_NOTICE_TITLE_IOS: 'Übrigens:',
    DREAM_MACHINE_INTERRUPTER_CARD_DESCRIPTION_2:
      'Sobald Du Dich anmeldest, zeigen wir Dir noch bessere Jobs.',
    DREAM_MACHINE_INTERRUPTER_CARD_DESCRIPTION_3:
      'Du bist nur wenige Klicks entfernt vom maßgeschneiderten Job-Feed.',
    DREAM_MACHINE_INTERRUPTER_CARD_DESCRIPTION_4:
      'Erstell Dein Profil und entdecke Deine berufliche Zukunft.',
    DREAM_MACHINE_INTERRUPTER_CARD_DESCRIPTION_5:
      'Verrate uns doch, wer Du bist! Dann zeigen wir Dir Jobs nach Deinen Fähigkeiten und Vorlieben.',
    DREAM_MACHINE_INTERRUPTER_CARD_LOGIN_BUTTON: 'Einloggen',
    DREAM_MACHINE_INTERRUPTER_CARD_REGISTER_BUTTON: 'Jetzt anmelden',
    DREAM_MACHINE_INTERRUPTER_CARD_TAG_1: 'Wunsch-Arbeitgeber',
    DREAM_MACHINE_INTERRUPTER_CARD_TAG_2: 'Wunsch-Tätigkeitsfeld',
    DREAM_MACHINE_INTERRUPTER_CARD_TAG_3: 'Karriere-Stufe',
    DREAM_MACHINE_INTERRUPTER_CARD_TITLE_1:
      'Sag uns, was Du suchst und Du kriegst ’nen maßgeschneiderten Feed.',
    DREAM_MACHINE_INTERRUPTER_CARD_TITLE_2: 'Das war’s … noch lange nicht!',
    DREAM_MACHINE_INTERRUPTER_CARD_TITLE_3:
      'Melde Dich an und mach nahtlos weiter.',
    DREAM_MACHINE_INTERRUPTER_CARD_TITLE_4:
      'Melde Dich an – dann kannst Du weiter swipen.',
    DREAM_MACHINE_INTERRUPTER_CARD_TITLE_5: 'Finde Jobs, die zu Dir passen.',
    DREAM_MACHINE_JOB_CARD_AVAILABLE_TOOLTIP_DESCRIPTION:
      'Wir möchten Dir einige freie Positionen zeigen, die zu Dir passen.',
    DREAM_MACHINE_JOB_CARD_AVAILABLE_TOOLTIP_TITLE: 'Neue Jobs für Dich',
    DREAM_MACHINE_JOB_CARD_COMPANY_TILE_CTA: 'Unternehmen ansehen',
    DREAM_MACHINE_JOB_CARD_EMPLOYMENT_TYPE_FULL_TIME: 'Full-time',
    DREAM_MACHINE_JOB_CARD_EMPLOYMENT_TYPE_PART_TIME: 'Part-time',
    DREAM_MACHINE_JOB_CARD_INDUSTRY_TITLE: 'Industry',
    DREAM_MACHINE_JOB_CARD_INFO_AVAILABLE:
      'Per E-Mail an Bewerbung erinnert werden',
    DREAM_MACHINE_JOB_CARD_INFO_OCCUPIED:
      'Lass Dich benachrichtigen, wenn er verfügbar wird.',
    DREAM_MACHINE_JOB_CARD_INFO_WILDCARD: 'Neue Karriere-Chancen erachließen',
    DREAM_MACHINE_JOB_CARD_KUNUNU_LABEL: 'kununu Score',
    DREAM_MACHINE_JOB_CARD_KUNUNU_REVIEWS: 'Bewertungen',
    DREAM_MACHINE_JOB_CARD_KUNUNU_REVIEWS_WEB: '{count} Bewertungen',
    DREAM_MACHINE_JOB_CARD_OCCUPANTS_PEEK_TITLE:
      'XING Mitglieder mit diesem Job',
    DREAM_MACHINE_JOB_CARD_OCCUPANTS_ROW_SUBTITLE_AVAILABLE:
      'Das könnte Dein nächster Job sein!',
    DREAM_MACHINE_JOB_CARD_OCCUPANTS_ROW_SUBTITLE_MULTIPLE: 'haben diesen Job.',
    DREAM_MACHINE_JOB_CARD_OCCUPANTS_ROW_SUBTITLE_SINGLE:
      'hat diesen Job in %s.',
    DREAM_MACHINE_JOB_CARD_OCCUPANTS_ROW_SUBTITLE_SINGLE_WEB:
      'lebt in {location} und hat diesen Job',
    DREAM_MACHINE_JOB_CARD_OCCUPANTS_ROW_TITLE: 'XING Mitglieder',
    DREAM_MACHINE_JOB_CARD_SALARY_PEEK_AVERAGE_LABEL:
      'Geschätztes Durchschnittsgehalt für vergleichbare Positionen',
    DREAM_MACHINE_JOB_CARD_SALARY_PEEK_BOOST: 'Boost',
    DREAM_MACHINE_JOB_CARD_SALARY_PEEK_NOTE:
      'Die unverbindliche Schätzung basiert auf der Anwendung verschiedener statistischer Verfahren, die unter Einbezug von anonymisierten XING Nutzerdaten und Marktdaten erstellt wurden. Einfluss auf die Spannweite der Gehaltsdaten haben folgende Variablen: Titel des Stellenangebots, Standort des Arbeitgebers, Unternehmensgröße, Branche und Karrierelevel vergleichbarer Positionen (soweit XING entsprechende Daten besitzt). Abweichungen zu tatsächlich von Inserenten gezahlten Gehältern sind möglich.',
    DREAM_MACHINE_JOB_CARD_SALARY_PEEK_RANGE_LABEL:
      'Geschätzte Gehaltsspanne für vergleichbare Positionen',
    DREAM_MACHINE_JOB_CARD_SALARY_PEEK_TITLE: 'Gehaltsprognose',
    DREAM_MACHINE_JOB_CARD_SALARY_ROW_TITLE: 'Mögliches Gehalt',
    DREAM_MACHINE_JOB_CARD_SALARY_ROW_TITLE_COMPACT: 'Gehalt',
    DREAM_MACHINE_JOB_CARD_SALARY_TILE_TITLE: 'Mögliches Gehalt',
    DREAM_MACHINE_JOB_CARD_SKILLS_ALERT_CONFIRMATION_DIALOG_ADD: 'Hinzufügen',
    DREAM_MACHINE_JOB_CARD_SKILLS_ALERT_CONFIRMATION_DIALOG_CANCEL: 'Abbrechen',
    DREAM_MACHINE_JOB_CARD_SKILLS_ALERT_CONFIRMATION_DIALOG_TITLE:
      'Ausgewählte Fähigkeiten jetzt hinzufügen?',
    DREAM_MACHINE_JOB_CARD_SKILLS_PEEK_ADD_CTA: 'Zum Profil hinzufügen',
    DREAM_MACHINE_JOB_CARD_SKILLS_PEEK_NOTE:
      'Kannst Du auch? Diese Fähigkeiten nennen XING Mitglieder mit diesem Job häufig in ihrem Profil.',
    DREAM_MACHINE_JOB_CARD_SKILLS_PROFILE_UPDATED:
      'Dein Profil wurde aktualisiert',
    DREAM_MACHINE_JOB_CARD_SKILLS_ROW_TITLE: 'Passende Fähigkeiten',
    DREAM_MACHINE_JOB_CARD_SKILLS_ROW_TITLE_COMPACT: 'Fähigkeiten',
    DREAM_MACHINE_JOB_CARD_SKILLS_TILE_TITLE: 'Passende Fähigkeiten',
    DREAM_MACHINE_JOB_CARD_SKILLS_TILE_TITLE_MATCH:
      'Fähigkeiten, die Du schon in Deinem Profil aufführst:',
    DREAM_MACHINE_JOB_CARD_SKILLS_TILE_TITLE_NOT_MATCH:
      'Fähigkeiten, die Du Deinem Profil hinzufügen könntest:',
    DREAM_MACHINE_JOB_CARD_TAKEN_TOOLTIP_DESCRIPTION:
      'Wir möchten Dir einige freie Positionen zeigen, die zu Dir passen.',
    DREAM_MACHINE_JOB_CARD_TAKEN_TOOLTIP_TITLE: 'Neue Jobs für Dich',
    DREAM_MACHINE_JOB_CARD_TYPE_AVAILABLE: 'Dieser Job ist verfügbar',
    DREAM_MACHINE_JOB_CARD_TYPE_AVAILABLE_COMPACT: 'Job verfügbar',
    DREAM_MACHINE_JOB_CARD_TYPE_AVAILABLE_SS: 'Job ist verfügbar',
    DREAM_MACHINE_JOB_CARD_TYPE_OCCUPIED: 'Dieser Job ist aktuell vergeben',
    DREAM_MACHINE_JOB_CARD_TYPE_OCCUPIED_A11Y:
      'Dieser Job ist aktuell vergeben',
    DREAM_MACHINE_JOB_CARD_TYPE_OCCUPIED_COMPACT: 'Job ist vergeben',
    DREAM_MACHINE_JOB_CARD_TYPE_OCCUPIED_SS: 'Job ist vergeben',
    DREAM_MACHINE_JOB_CARD_TYPE_WILDCARD: 'Wildcard',
    DREAM_MACHINE_JOB_REMINDER_BUTTON_DISABLE_A11Y:
      'Bewerbungswecker für {variable_1} deaktivieren',
    DREAM_MACHINE_JOB_REMINDER_BUTTON_ENABLE_A11Y:
      'Bewerbungswecker für {variable_1} aktivieren',
    DREAM_MACHINE_LOGO_A11Y: 'XING Logo',
    DREAM_MACHINE_MORE_MENU_ITEM_LABEL_ABOUT_AVAILABLE_JOBS:
      'Hinweis zu Job-Vorschlägen',
    DREAM_MACHINE_MORE_MENU_ITEM_LABEL_ABOUT_OCCUPIED_JOBS: 'Wichtiger Hinweis',
    DREAM_MACHINE_UPSELL_CTA: 'Premium werden',
    DREAM_MACHINE_UPSELL_CTA_SECONDARY: 'Zeig mir erst noch weitere Karten!',
    DREAM_MACHINE_UPSELL_DESCRIPTION:
      'Mit Premium erfährst Du, wer Dein Profil besucht hat und was ihr gemeinsam habt.',
    DREAM_MACHINE_UPSELL_LARGE_TITLE_LINE_1: 'Über 10 Mitglieder',
    DREAM_MACHINE_UPSELL_LARGE_TITLE_LINE_2: 'haben Dein Profil besucht!',
    DREAM_MACHINE_UPSELL_TITLE_LINE_1: '3 Mitglieder',
    DREAM_MACHINE_UPSELL_TITLE_LINE_2: 'haben Dein Profil besucht!',
    JOBS_FIND_JOBS_FLEXITIME_OPTION_FLEXITIME: 'Flexible Arbeitszeiten',
    JOBS_FIND_JOBS_HEADER_TITLE: 'Finde den Job, der zu Dir passt.',
    JOBS_FIND_JOBS_PART_TIME_OPTION_PART_TIME: 'Teilzeit',
    JOBS_FIND_JOBS_RECRUITERS_LINK: 'Jobs posten? <a>Geht hier.</a>',
    JOBS_FIND_JOBS_RECRUITERS_LINK_FIRST_LINE: 'Jobs posten?',
    JOBS_FIND_JOBS_RECRUITERS_LINK_SECOND_LINE: 'Geht hier.',
    JOBS_FIND_JOBS_REMOTE_OPTION_FULL_REMOTE: 'Im Home-Office',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Jobs finden',
    JOBS_FIND_JOBS_SEARCH_LOCATION_PLACEHOLDER: 'Standort',
    JOBS_FIND_JOBS_SEARCH_PLACEHOLDER: 'Job-Titel eingeben',
    JOBS_FIND_JOBS_SEARCH_RADIUS_PLACEHOLDER: 'Umkreis',
    JOBS_FIND_JOBS_TITLE: 'Jobs finden',
    JOBS_RECENT_SEARCH_EMPTY: 'Alle Jobs',
    JOBS_SEARCH_AI_ENTRYPOINT_BANNER: 'Neu: Finde Deinen Job mit KI',
    JOBS_SEARCH_AI_ENTRYPOINT_FLAG_DESKTOP: 'Jetzt testen',
    JOBS_SEARCH_AI_ENTRYPOINT_FLAG_MOBILE: 'Jetzt testen',
    JOBS_SEARCH_AI_HEADLINE: 'Beschreib der XING KI Deinen Wunsch-Job',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_1: 'Beschreib mal Deinen Traumjob …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_10:
      'Erzähl auch von Deinen Erfahrungen und Fähigkeiten …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_2:
      'Schreib einfach in ganz natürlicher Sprache …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_3: 'Jobs, die Du gern machen würdest …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_4:
      'Deine Ideen für Deinen nächsten Karriere-Schritt …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_5:
      'Job-Titel, Karriere-Stufe, Wunsch-Gehalt, …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_6:
      'Alles, was Dir im Job-Leben wichtig ist …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_7: 'Je konkreter, desto besser …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_8:
      'Teilzeit oder Vollzeit, Büro oder Home-Office, …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_9:
      'Lieber einfache Sätze statt viele Schlagwörter …',
    JOBS_SEARCH_AI_PLACEHOLDER_1:
      'Beschreib mal Deinen Traum-Job. Leg einfach los …',
    JOBS_SEARCH_AI_PLACEHOLDER_2:
      'Jedes Wort, jede Zahl, jede Info hilft für bessere Ergebnisse …',
    JOBS_SEARCH_AI_PLACEHOLDER_3:
      'Job-Titel, Karriere-Stufe, Wunsch-Branche, …',
    JOBS_SEARCH_AI_PLACEHOLDER_4:
      'Teilzeit oder Vollzeit? Büro oder Home-Office?',
    JOBS_SEARCH_AI_PLACEHOLDER_5: 'Nenn auch Deine Stärken und Fähigkeiten …',
    JOBS_SEARCH_AI_PLACEHOLDER_6: 'Und verrate, was Du verdienen willst …',
    JOBS_SEARCH_AI_PLACEHOLDER_7:
      'Probier einfach ein bisschen rum und spiel mit dem Text …',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION: 'Such mit meinem Profil',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION_SUBTITLE: 'Finde Deinen nächsten Job',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION: 'Hilfe beim Quereinstieg',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION_SUBTITLE:
      'Entdecke mit XING völlig neue Karriere-Chancen.',
    JOBS_SEARCH_LOCATION_NO_RADIUS: 'Kein Umkreis',
    KUNUNU_RATING_CONTENT_DESCRIPTION_A11Y:
      'Die Bewertung dieses Arbeitgebers auf kununu ist: %1$.1f von 5 Sternen',
    SEARCH_AND_SHUFFLE_AVAILABLE_JOB_BUTTON_ALERT_A11Y: 'Add reminder',
    SEARCH_AND_SHUFFLE_BUTTON_DISCARD_A11Y: 'Discard',
    SEARCH_AND_SHUFFLE_FILTER_LABEL: 'Anzeigen:',
    SEARCH_AND_SHUFFLE_JOB_CARD_ERROR_RECOMMENDATIONS_BUTTON:
      'Job-Wünsche anpassen',
    SEARCH_AND_SHUFFLE_JOB_CARD_ERROR_RECOMMENDATIONS_BUTTON_SECONDARY:
      'Profil updaten',
    SEARCH_AND_SHUFFLE_JOB_CARD_ERROR_RECOMMENDATIONS_DESCRIPTION:
      'Bring doch in der Zwischenzeit Deine Job-Wünsche und Dein Profil auf Stand – für noch bessere Empfehlungen. ',
    SEARCH_AND_SHUFFLE_JOB_CARD_ERROR_RECOMMENDATIONS_TITLE:
      'Hier siehst Du gleich ein paar spannende Jobs',
    SEARCH_AND_SHUFFLE_MODAL_CLOSE: 'Ansicht schließen',
    SEARCH_AND_SHUFFLE_MODAL_REMINDER_DISABLED:
      'Du erhältst keine Erinnerungen für diesen Job.',
    SEARCH_AND_SHUFFLE_MODAL_REMINDER_DISABLED_CTA:
      'Bewerbungswecker aktivieren',
    SEARCH_AND_SHUFFLE_MODAL_REMINDER_DISABLED_DESCRIPTION:
      'Lass Dich benachrichtigen, wenn er verfügbar wird.',
    SEARCH_AND_SHUFFLE_MODAL_REMINDER_ENABLED:
      'Du erhältst Erinnerungen für diesen Job.',
    SEARCH_AND_SHUFFLE_MODAL_REMINDER_ENABLED_CTA:
      'Bewerbungswecker deaktivieren',
    SEARCH_AND_SHUFFLE_MODAL_REMINDER_ENABLED_DESCRIPTION:
      'Wir schicken Dir eine E-Mail, sobald dieser Job verfügbar ist.',
    SEARCH_AND_SHUFFLE_SHUFFLE_BUTTON_LABEL: 'Alles mischen',
    SEARCH_AND_SHUFFLE_STATUS_BANNER_BOOKMARK_DISABLED:
      '<b>Du merkst Dir diesen Job jetzt nicht mehr</b> und wir haben ihn von der entsprechenden Liste entfernt.',
    SEARCH_AND_SHUFFLE_STATUS_BANNER_BOOKMARK_ENABLED:
      '<b>Du hast Dir diesen Job gemerkt</b> und wir haben ihn der entsprechenden Liste hinzugefügt.',
    SEARCH_AND_SHUFFLE_STATUS_BANNER_LIKE_LOGGED_OUT:
      'Dir gefällt dieser Job? {login}, um mehr zu erfahren oder eine Info zu bekommen, sobald er frei wird.',
    SEARCH_AND_SHUFFLE_STATUS_BANNER_LIKE_LOGGED_OUT_LINK: 'Melde Dich an',
    SEARCH_AND_SHUFFLE_STATUS_BANNER_REMINDER_DISABLED:
      'Bewerbungswecker deaktiviert. Du erhältst keine Erinnerungen mehr.',
    SEARCH_AND_SHUFFLE_STATUS_BANNER_REMINDER_ENABLED:
      'Du erhältst Erinnerungen für diesen Job. ',
    SEARCH_AND_SHUFFLE_TAKEN_JOB_BUTTON_BOOKMARK_A11Y: 'Bookmark',
    SEARCH_AND_SHUFFLE_YOUR_JOBS_TITLE: 'Deine Jobs',
    SEARCH_AND_SWIPE_ALL_JOBS: 'Alle Jobs',
    SEARCH_AND_SWIPE_AVAILABLE_JOBS_ONLY: 'Nur offene Stellen',
    SEARCH_AND_SWIPE_CHANGE_CAREER: 'Hilfe beim Quereinstieg',
    SEARCH_AND_SWIPE_SEARCH_ALERT_NEW_RESULTS_LABEL: 'Neue Jobs',
    SEARCH_AND_SWIPE_SEARCH_BAR_A11Y: 'Text für Job-Suche eingeben',
    SEARCH_AND_SWIPE_SEARCH_WITH_AI: 'Finde Deinen Job mit KI',
    SEARCH_AND_SWIPE_SEARCH_WITH_MY_PROFILE: 'Such mit meinem Profil',
    SEARCH_AND_SWIPE_TAKEN_JOBS_ONLY: 'Nur besetzte Stellen',
    SEARCH_AND_SWIPE_TOOLTIP_BODY:
      'Entdecke spannende Jobs und Profile, lass Dich für Deinen nächsten Karriereschritt inspirieren und finde Deinen Wunsch-Job von morgen – einfach per Klick.',
  },
};
